module.exports = "<h3>{{ ::$ctrl.stateTitle }}</h3> <span flex></span> <md-button class=\"md-icon-button effect-rollover\" ng-class=\"{'is-active': $ctrl.isActive}\" ng-click=$ctrl.showHelpMenu($event); aria-label=\"Open help menu\"> <i md-menu-origin class=material-icons>help</i> <md-tooltip md-direction=left class=dt-theme>Help & Support</md-tooltip> </md-button> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/content-header/content-header.html
// module id = uPUl
// module chunks = 1